import axios from 'axios';

const responder = (idSolicitacao, negociacao) => axios.post(`/fornecedor/negociacoes/${idSolicitacao}`, negociacao);
const getNegociacoes = (idSolicitacao) => axios.get(`/fornecedor/negociacoes/${idSolicitacao}`);

export default {
  responder,
  getNegociacoes,
};
